const MAX_WORKGROUP_NAME_LENGTH = 100;

const TAGS = [
    'ticket_management.form.workgroup.search.select',
    'ticket_management.form.workgroup.search.contains',
    'ticket_management.form.workgroup.search.notContains',
];

enum IS_DEFAULT_WORKGROUP {
    YES = 'Y',
    NO = 'N',
}

enum WORKGROUP_TAG {
    SELECT = 'ticket_management.form.workgroup.search.select',
    CONTAINS = 'ticket_management.form.workgroup.search.contains',
    NOT_CONTAINS = 'ticket_management.form.workgroup.search.notContains',
}

enum RESPONSE_STATUS {
    SUCCESS = 'success',
    FAILURE = 'failure',
}

export { IS_DEFAULT_WORKGROUP, WORKGROUP_TAG, RESPONSE_STATUS, TAGS, MAX_WORKGROUP_NAME_LENGTH };